import { render, staticRenderFns } from "./ArticleAuthor.vue?vue&type=template&id=956a3138&"
import script from "./ArticleAuthor.ts?vue&type=script&lang=ts&"
export * from "./ArticleAuthor.ts?vue&type=script&lang=ts&"
import style0 from "./ArticleAuthor.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports